// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/update_my_job_alerts.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/update_my_job_alerts.proto.
 */
export const file_accounts_update_my_job_alerts: GenFile = /*@__PURE__*/
  fileDesc("CiNhY2NvdW50cy91cGRhdGVfbXlfam9iX2FsZXJ0cy5wcm90bxIPcHJvdG9zLmFjY291bnRzIq0BChhVcGRhdGVNeUpvYkFsZXJ0c1JlcXVlc3QSQAoGcGFyYW1zGAEgASgLMjAucHJvdG9zLmFjY291bnRzLlVwZGF0ZU15Sm9iQWxlcnRzUmVxdWVzdC5QYXJhbXMSLwoLdXBkYXRlX21hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrGh4KBlBhcmFtcxIUCgxzZW5kX2J5X3B1c2gYASABKAgiaAoZVXBkYXRlTXlKb2JBbGVydHNSZXNwb25zZRJBCgZyZXN1bHQYASABKAsyMS5wcm90b3MuYWNjb3VudHMuVXBkYXRlTXlKb2JBbGVydHNSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM", [file_google_protobuf_field_mask]);

/**
 * @generated from message protos.accounts.UpdateMyJobAlertsRequest
 */
export type UpdateMyJobAlertsRequest = Message<"protos.accounts.UpdateMyJobAlertsRequest"> & {
  /**
   * @generated from field: protos.accounts.UpdateMyJobAlertsRequest.Params params = 1;
   */
  params?: UpdateMyJobAlertsRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.accounts.UpdateMyJobAlertsRequest.
 * Use `create(UpdateMyJobAlertsRequestSchema)` to create a new message.
 */
export const UpdateMyJobAlertsRequestSchema: GenMessage<UpdateMyJobAlertsRequest> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_job_alerts, 0);

/**
 * @generated from message protos.accounts.UpdateMyJobAlertsRequest.Params
 */
export type UpdateMyJobAlertsRequest_Params = Message<"protos.accounts.UpdateMyJobAlertsRequest.Params"> & {
  /**
   * @generated from field: bool send_by_push = 1;
   */
  sendByPush: boolean;
};

/**
 * Describes the message protos.accounts.UpdateMyJobAlertsRequest.Params.
 * Use `create(UpdateMyJobAlertsRequest_ParamsSchema)` to create a new message.
 */
export const UpdateMyJobAlertsRequest_ParamsSchema: GenMessage<UpdateMyJobAlertsRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_job_alerts, 0, 0);

/**
 * @generated from message protos.accounts.UpdateMyJobAlertsResponse
 */
export type UpdateMyJobAlertsResponse = Message<"protos.accounts.UpdateMyJobAlertsResponse"> & {
  /**
   * @generated from field: protos.accounts.UpdateMyJobAlertsResponse.Result result = 1;
   */
  result?: UpdateMyJobAlertsResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.UpdateMyJobAlertsResponse.
 * Use `create(UpdateMyJobAlertsResponseSchema)` to create a new message.
 */
export const UpdateMyJobAlertsResponseSchema: GenMessage<UpdateMyJobAlertsResponse> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_job_alerts, 1);

/**
 * @generated from message protos.accounts.UpdateMyJobAlertsResponse.Result
 */
export type UpdateMyJobAlertsResponse_Result = Message<"protos.accounts.UpdateMyJobAlertsResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.UpdateMyJobAlertsResponse.Result.
 * Use `create(UpdateMyJobAlertsResponse_ResultSchema)` to create a new message.
 */
export const UpdateMyJobAlertsResponse_ResultSchema: GenMessage<UpdateMyJobAlertsResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_update_my_job_alerts, 1, 0);

